import { useState } from 'react';
import Navbar from '@/components/feature/Navbar';
import Footer from '@/components/feature/Footer';
import Breadcrumb from '@/components/feature/Breadcrumb';
import ScrollToTop from '@/components/feature/ScrollToTop';
import { articles } from '@/mocks/articles';

export default function AboutPage() {
  const [formStatus, setFormStatus] = useState<'idle' | 'loading' | 'success' | 'error'>('idle');
  const [formError, setFormError] = useState('');

  const totalViews = articles.reduce((sum, a) => sum + a.views, 0);
  const totalComments = articles.reduce((sum, a) => sum + a.comments, 0);

  const handleSubmit = async (e: React.FormEvent<HTMLFormElement>) => {
    e.preventDefault();
    const form = e.currentTarget;
    const honeypotField = form.querySelector<HTMLInputElement>('input[name="phone_alt"]');
    if (honeypotField && honeypotField.value.trim() !== '') {
      setFormStatus('success');
      return;
    }
    setFormStatus('loading');
    setFormError('');
    const formData = new FormData(form);
    try {
      const response = await fetch('https://readdy.ai/api/form/d9qsgq7nahb7382oveu0', {
        method: 'POST',
        body: new URLSearchParams(formData as unknown as Record<string, string>),
        headers: { 'Content-Type': 'application/x-www-form-urlencoded' },
      });
      const responseText = await response.text();
      let parsed;
      try {
        parsed = JSON.parse(responseText);
      } catch {
        setFormError('服务器响应异常，请稍后再试');
        setFormStatus('error');
        return;
      }
      if (response.ok && parsed?.code === 'OK') {
        setFormStatus('success');
        form.reset();
      } else {
        const serverMsg = parsed?.meta?.message || parsed?.message || parsed?.meta?.detail || responseText;
        if (typeof serverMsg === 'string' && (serverMsg.toLowerCase().includes('spam') || serverMsg.includes('form data is spam'))) {
          setFormError('提交失败，请检查输入内容后重试');
        } else {
          setFormError(serverMsg || '提交失败，请稍后再试');
        }
        setFormStatus('error');
      }
    } catch {
      setFormError('网络错误，请检查连接后重试');
      setFormStatus('error');
    }
  };

  const seoData = {
    title: '关于我们 - 黑料在线',
    description: '了解黑料在线品牌故事与发展历程。黑料在线是领先的独家黑料内容聚合平台，致力于为用户提供最新、最全的娱乐圈、网红、明星等爆料资讯。查看我们的口碑评价与联系方式。',
    keywords: '黑料在线,关于黑料在线,黑料在线品牌,黑料在线联系方式,爆料平台',
    canonical: 'https://heiliao-online.com/about',
  };

  return (
    <>
      <ScrollToTop />
      <head>
        <title>{seoData.title}</title>
        <meta name="description" content={seoData.description} />
        <meta name="keywords" content={seoData.keywords} />
        <link rel="canonical" href={seoData.canonical} />
        <meta property="og:title" content={seoData.title} />
        <meta property="og:description" content={seoData.description} />
        <meta property="og:type" content="website" />
        <meta property="og:url" content={seoData.canonical} />
        <meta property="og:site_name" content="黑料在线" />
        <meta name="twitter:card" content="summary_large_image" />
        <meta name="twitter:title" content={seoData.title} />
        <meta name="twitter:description" content={seoData.description} />
        <script type="application/ld+json">
          {JSON.stringify({
            "@context": "https://schema.org",
            "@type": "AboutPage",
            "name": seoData.title,
            "description": seoData.description,
            "url": seoData.canonical,
            "inLanguage": "zh-CN",
            "isPartOf": {
              "@type": "WebSite",
              "name": "黑料在线",
              "url": "https://heiliao-online.com"
            }
          })}
        </script>
        <script type="application/ld+json">
          {JSON.stringify({
            "@context": "https://schema.org",
            "@type": "BreadcrumbList",
            "itemListElement": [
              { "@type": "ListItem", "position": 1, "name": "首页", "item": "https://heiliao-online.com" },
              { "@type": "ListItem", "position": 2, "name": "关于我们" }
            ]
          })}
        </script>
        <script type="application/ld+json">
          {JSON.stringify({
            "@context": "https://schema.org",
            "@type": "FAQPage",
            "mainEntity": [
              {
                "@type": "Question",
                "name": "黑料在线的内容来源是否可靠？",
                "acceptedAnswer": {
                  "@type": "Answer",
                  "text": "黑料在线拥有广泛的独家信源网络，所有爆料内容均经过多维度交叉验证，确保信息的真实性和可靠性。我们与多位资深娱记、行业内部人士保持长期合作关系。"
                }
              },
              {
                "@type": "Question",
                "name": "黑料在线更新频率如何？",
                "acceptedAnswer": {
                  "@type": "Answer",
                  "text": "黑料在线实行7x24小时全天候内容更新机制，编辑团队实时追踪最新动态，确保用户第一时间获取最劲爆的内幕消息。每天平均更新数十条独家内容。"
                }
              },
              {
                "@type": "Question",
                "name": "如何联系黑料在线进行爆料投稿？",
                "acceptedAnswer": {
                  "@type": "Answer",
                  "text": "您可以通过本页面的联系表单提交爆料线索，或发送邮件至我们的官方邮箱。我们承诺对所有爆料人的信息严格保密，重大独家爆料线索将获得丰厚报酬。"
                }
              },
              {
                "@type": "Question",
                "name": "黑料在线是否涉及侵犯隐私？",
                "acceptedAnswer": {
                  "@type": "Answer",
                  "text": "黑料在线严格遵守法律法规，所有报道均在合法范围内进行。我们坚持新闻伦理底线，不传播未经核实的虚假信息，不涉及纯粹的个人隐私侵犯。如发现不实内容，欢迎通过联系渠道进行反馈。"
                }
              }
            ]
          })}
        </script>
      </head>

      <div className="min-h-screen bg-background-50">
        <Navbar />

        <main className="pt-20">
          <div className="max-w-[1280px] mx-auto px-4 md:px-6 py-6">
            <Breadcrumb
              items={[
                { label: '首页', href: '/' },
                { label: '关于我们' },
              ]}
            />
          </div>

          <section className="max-w-[1280px] mx-auto px-4 md:px-6 mb-14">
            <div className="text-center mb-10">
              <h1 className="text-3xl md:text-4xl font-bold text-foreground-950 mb-4">关于黑料在线</h1>
              <p className="text-lg text-foreground-500 max-w-3xl mx-auto leading-relaxed">
                黑料在线是国内领先的独家黑料内容聚合平台，致力于为用户提供最新、最全、最真实的娱乐爆料资讯。
                我们深耕娱乐圈、网红圈、明星圈等多个领域，以深度挖掘真相为己任，让每一位用户都能第一时间掌握最劲爆的内幕消息。
              </p>
            </div>

            <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-4 gap-4 mb-14">
              {[
                { number: `${articles.length}+`, label: '独家爆料' },
                { number: `${(totalViews / 10000).toFixed(0)}万+`, label: '累计阅读' },
                { number: `${(totalComments / 10000).toFixed(0)}万+`, label: '用户互动' },
                { number: '6', label: '内容分类' },
              ].map((stat, idx) => (
                <div key={idx} className="bg-background-50 rounded-lg p-6 text-center border border-background-200/70">
                  <div className="text-3xl md:text-4xl font-bold text-foreground-950 mb-1 whitespace-nowrap">{stat.number}</div>
                  <div className="text-sm text-foreground-500 whitespace-nowrap">{stat.label}</div>
                </div>
              ))}
            </div>

            <div className="grid grid-cols-1 lg:grid-cols-2 gap-10 mb-14">
              <div>
                <h2 className="text-2xl font-bold text-foreground-950 mb-4">品牌故事</h2>
                <div className="space-y-4 text-foreground-600 leading-relaxed">
                  <p>
                    黑料在线诞生于2024年，由一群对娱乐资讯充满热情的资深媒体人共同创立。我们深知在信息爆炸的时代，用户需要的不仅仅是海量信息，更是真实、有深度、值得信赖的内容。
                  </p>
                  <p>
                    经过两年多的发展，黑料在线已成长为国内最具影响力的娱乐爆料平台之一。我们的编辑团队由资深娱记、行业分析师和内容运营专家组成，全天候追踪娱乐圈、网红圈、明星圈的最新动态。
                  </p>
                  <p>
                    我们始终坚持以用户为中心，不断优化内容质量和阅读体验。无论是页面设计、内容呈现还是互动功能，我们都精益求精，力求为每一位用户带来最好的资讯消费体验。
                  </p>
                </div>
              </div>

              <div>
                <h2 className="text-2xl font-bold text-foreground-950 mb-4">核心优势</h2>
                <div className="space-y-4">
                  {[
                    { icon: 'ri-flashlight-line', title: '独家信源网络', desc: '与数百位业内人士保持长期合作关系，确保信息的独家性和时效性。' },
                    { icon: 'ri-shield-check-line', title: '多维度验证', desc: '每一条爆料均经过至少三个独立信源的交叉验证，确保内容真实可靠。' },
                    { icon: 'ri-speed-line', title: '极速响应', desc: '7x24小时全天候追踪，重大爆料从发生到发布平均仅需15分钟。' },
                    { icon: 'ri-user-heart-line', title: '用户至上', desc: '持续倾听用户反馈，不断优化内容方向和产品体验。' },
                  ].map((item, idx) => (
                    <div key={idx} className="flex gap-4 p-4 bg-background-50 rounded-lg border border-background-200/70">
                      <div className="w-10 h-10 flex-shrink-0 flex items-center justify-center rounded-full bg-background-100">
                        <i className={`${item.icon} text-lg text-foreground-950`}></i>
                      </div>
                      <div>
                        <h3 className="text-base font-semibold text-foreground-950 mb-1 whitespace-nowrap">{item.title}</h3>
                        <p className="text-sm text-foreground-500 leading-relaxed">{item.desc}</p>
                      </div>
                    </div>
                  ))}
                </div>
              </div>
            </div>

            <div className="mb-14">
              <h2 className="text-2xl font-bold text-foreground-950 mb-6 text-center">用户口碑</h2>
              <div className="grid grid-cols-1 md:grid-cols-3 gap-5">
                {[
                  { name: '张先生', role: '资深娱评人', content: '黑料在线的独家爆料速度和准确度令人惊叹，是我每天必看的信息来源。很多独家内容在其他平台根本看不到，非常推荐！', rating: 5 },
                  { name: '李女士', role: '娱乐博主', content: '作为同行，我深知挖掘独家爆料的难度。黑料在线的内容质量在业内绝对是顶尖水平，信息验证非常到位。真心佩服他们的专业度！', rating: 5 },
                  { name: '王先生', role: '忠实用户', content: '关注黑料在线快一年了，可以说是我用过的最好的娱乐资讯平台。界面清爽、内容硬核，已经推荐给身边所有朋友了。', rating: 5 },
                ].map((review, idx) => (
                  <div key={idx} className="bg-background-50 rounded-lg p-6 border border-background-200/70">
                    <div className="flex items-center gap-1 mb-3">
                      {Array.from({ length: review.rating }).map((_, i) => (
                        <i key={i} className="ri-star-fill text-accent-500 text-sm"></i>
                      ))}
                    </div>
                    <p className="text-sm text-foreground-600 leading-relaxed mb-4">&ldquo;{review.content}&rdquo;</p>
                    <div className="flex items-center gap-3">
                      <div className="w-9 h-9 rounded-full bg-background-100 flex items-center justify-center">
                        <span className="text-sm font-semibold text-foreground-700">{review.name[0]}</span>
                      </div>
                      <div>
                        <div className="text-sm font-semibold text-foreground-950 whitespace-nowrap">{review.name}</div>
                        <div className="text-xs text-foreground-500 whitespace-nowrap">{review.role}</div>
                      </div>
                    </div>
                  </div>
                ))}
              </div>
            </div>

            <div className="grid grid-cols-1 lg:grid-cols-2 gap-10">
              <div>
                <h2 className="text-2xl font-bold text-foreground-950 mb-2">联系我们</h2>
                <p className="text-foreground-500 mb-6">
                  如果您有独家爆料线索或任何问题，欢迎通过以下方式联系我们。
                  我们承诺对所有爆料人的信息严格保密。
                </p>

                <div className="space-y-4 mb-8">
                  <div className="flex items-center gap-3">
                    <div className="w-10 h-10 flex-shrink-0 flex items-center justify-center rounded-full bg-background-100">
                      <i className="ri-mail-line text-lg text-foreground-950"></i>
                    </div>
                    <div>
                      <div className="text-sm font-medium text-foreground-950 whitespace-nowrap">电子邮箱</div>
                      <div className="text-sm text-foreground-500">tips@heiliao-online.com</div>
                    </div>
                  </div>
                  <div className="flex items-center gap-3">
                    <div className="w-10 h-10 flex-shrink-0 flex items-center justify-center rounded-full bg-background-100">
                      <i className="ri-map-pin-line text-lg text-foreground-950"></i>
                    </div>
                    <div>
                      <div className="text-sm font-medium text-foreground-950 whitespace-nowrap">办公地址</div>
                      <div className="text-sm text-foreground-500">北京市朝阳区建国路88号SOHO现代城A座</div>
                    </div>
                  </div>
                </div>
              </div>

              <div>
                <div className="bg-background-50 rounded-lg p-6 border border-background-200/70">
                  <h3 className="text-lg font-semibold text-foreground-950 mb-5 whitespace-nowrap">发送消息</h3>
                  <form
                    onSubmit={handleSubmit}
                    data-readdy-form
                    className="space-y-4"
                  >
                    <div>
                      <label htmlFor="name" className="block text-sm font-medium text-foreground-700 mb-1.5 whitespace-nowrap">您的姓名</label>
                      <input
                        type="text"
                        id="name"
                        name="name"
                        required
                        className="w-full px-3.5 py-2.5 rounded-lg border border-background-200/70 bg-background-50 text-sm text-foreground-950 placeholder:text-foreground-400 focus:outline-none focus:border-foreground-300 transition-colors"
                        placeholder="请输入您的姓名"
                      />
                    </div>
                    <div>
                      <label htmlFor="email" className="block text-sm font-medium text-foreground-700 mb-1.5 whitespace-nowrap">电子邮箱</label>
                      <input
                        type="email"
                        id="email"
                        name="email"
                        required
                        className="w-full px-3.5 py-2.5 rounded-lg border border-background-200/70 bg-background-50 text-sm text-foreground-950 placeholder:text-foreground-400 focus:outline-none focus:border-foreground-300 transition-colors"
                        placeholder="请输入您的邮箱"
                      />
                    </div>
                    <div>
                      <label htmlFor="subject" className="block text-sm font-medium text-foreground-700 mb-1.5 whitespace-nowrap">主题</label>
                      <input
                        type="text"
                        id="subject"
                        name="subject"
                        required
                        className="w-full px-3.5 py-2.5 rounded-lg border border-background-200/70 bg-background-50 text-sm text-foreground-950 placeholder:text-foreground-400 focus:outline-none focus:border-foreground-300 transition-colors"
                        placeholder="请选择主题"
                      />
                    </div>
                    <div>
                      <label htmlFor="message" className="block text-sm font-medium text-foreground-700 mb-1.5 whitespace-nowrap">消息内容</label>
                      <textarea
                        id="message"
                        name="message"
                        required
                        maxLength={500}
                        rows={4}
                        className="w-full px-3.5 py-2.5 rounded-lg border border-background-200/70 bg-background-50 text-sm text-foreground-950 placeholder:text-foreground-400 focus:outline-none focus:border-foreground-300 transition-colors resize-none"
                        placeholder="请输入您的消息（最多500字）"
                      ></textarea>
                    </div>

                    <input
                      type="text"
                      name="phone_alt"
                      tabIndex={-1}
                      autoComplete="off"
                      aria-hidden="true"
                      readOnly
                      className="form-honeypot"
                    />

                    <button
                      type="submit"
                      disabled={formStatus === 'loading'}
                      className="w-full px-6 py-2.5 bg-foreground-950 text-background-50 rounded-full text-sm font-medium whitespace-nowrap transition-all duration-200 hover:bg-foreground-800 disabled:opacity-50 disabled:cursor-not-allowed"
                    >
                      {formStatus === 'loading' ? '发送中...' : '发送消息'}
                    </button>

                    {formStatus === 'success' && (
                      <div className="text-sm text-green-600 bg-green-50 rounded-lg px-4 py-3 text-center">
                        消息发送成功！我们会尽快与您取得联系。
                      </div>
                    )}
                    {formStatus === 'error' && formError && (
                      <div className="text-sm text-red-600 bg-red-50 rounded-lg px-4 py-3 text-center">
                        {formError}
                      </div>
                    )}
                  </form>
                </div>
              </div>
            </div>
          </section>
        </main>

        <Footer />
      </div>
    </>
  );
}